import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/styles/withStyles';
import {acceptTermsAndConditions} from "../util/ApiUtils";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { SchoolTwoTone } from "@material-ui/icons";
import PropTypes from "prop-types";
import BrowsePdf from "./common/BrowsePdf";
import {TNC_URL_PATH} from "../Constants";
import TextField from "@material-ui/core/TextField";
import SignaturePad from "react-signature-canvas";
import {GreyButton} from "./common/ButtonsConstants";
import Paper from "@material-ui/core/Paper";

const classes = (theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

class TermsAndConditions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            fullName: props.user ? props.user.acceptedTnCfullName : "",
            driverLicenceNumber: props.user ? props.user.driverLicenceNumber : "",
            signature: props.user ? props.user.signature : "",
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
    }

    onSignatureDrawn(fieldName, sigPad) {
        console.log('onSignatureDrawn called', fieldName);
        this.setState({
            ...this.state, [fieldName]: sigPad.toDataURL('image/png')
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        // TODO validate first???
        if (!this.state.isChecked || !this.state.signature || !this.state.fullName || !this.state.driverLicenceNumber) {
            NotificationManager.warning('Warning', 'Please Accept the Terms and Conditions before continue', 5000);
        } else {
            const termsAndConditionsRequest = Object.assign({},
                {
                    isChecked: this.state.isChecked,
                    fullName: this.state.fullName,
                    driverLicenceNumber: this.state.driverLicenceNumber,
                    signature: this.state.signature,
                }
            );
            acceptTermsAndConditions(termsAndConditionsRequest)
            .then(response => {
                this.props.handleTAndC(response);
            }).catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
        }
        /*this.props.form.validateFields((err, values) => {
            if (!err) {

        });*/
    }

    toggleChange = () => {
        this.setState({
            isChecked: !this.state.isChecked,
        });
    };

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <SchoolTwoTone/>
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Terms & Conditions
                        </Typography>
                        <BrowsePdf urlPath={TNC_URL_PATH}/>
                        <Container component="main" maxWidth="sm">
                            <form onSubmit={this.handleSubmit} className={classes.form}>
                                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="fullName"
                                            name="fullName"
                                            value={this.state.fullName}
                                            label="Full Name"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                            inputProps={
                                                { disabled: !this.props.handleTAndC, }
                                            }
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="driverLicenceNumber"
                                            name="driverLicenceNumber"
                                            value={this.state.driverLicenceNumber}
                                            label="Driver Licence Number"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                            inputProps={
                                                { disabled: !this.props.handleTAndC, }
                                            }
                                        />
                                    </div>
                                    <Paper className={classes.paper} square>
                                        <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                            Signature (please use mouse or touchpad to sign):
                                            <SignaturePad
                                                canvasProps={{ width: "250px", height: "150px" }}
                                                onEnd={() => this.onSignatureDrawn('signature', this.sigPad)}
                                                ref={(ref) => {
                                                    this.sigPad = ref;
                                                    if (this.state.signature && this.sigPad) {
                                                        this.sigPad.fromDataURL(this.state.signature, { width: 250, height: 150})
                                                    }
                                                    if (!this.props.handleTAndC && this.sigPad) {
                                                        this.sigPad.off();
                                                    }
                                                }}
                                            />
                                            {this.props.handleTAndC && (
                                            <GreyButton onClick={() => this.sigPad.clear()}>
                                                CLEAR
                                            </GreyButton>)}
                                        </div>
                                    </Paper>
                                    <FormControlLabel
                                        control={<Checkbox value="acceptTnC" color="primary" onChange={this.toggleChange} disabled={this.props.handleTAndC === undefined}/>}
                                        label={`By checking this box, I agree to the Terms of Service.`}
                                    />
                                </div>
                                {this.props.handleTAndC && (
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    Accept Terms & Conditions
                                </Button>)}
                            </form>
                        </Container>
                    </div>
                    <NotificationContainer/>
                </Container>
            </div>
        );
    }
}

TermsAndConditions.propTypes = {
    handleTAndC: PropTypes.func,
    user: PropTypes.object,
};

export default withStyles(classes)(TermsAndConditions);